import { getStore } from 'core_main/store';
import { evaluateRule, getChatActionFromRule } from './helpers';
import { GetAssistantParameters, GetAssistantResponse } from './types';

export const getAssistant = (
  params: GetAssistantParameters,
): GetAssistantResponse | false => {
  const store = getStore();
  const customer = params.customer ?? store.customerContext;
  const assistantRules = store?.settings?.assistantRules;
  const proactive = !!params.proactiveOnly;
  if (Array.isArray(assistantRules)) {
    const filteredRules = proactive
      ? assistantRules.filter(
          (rule) =>
            getChatActionFromRule(rule)?.input?.pendingAssistant
              ?.isProactive === true,
        )
      : assistantRules;
    for (let i = 0; i < filteredRules.length; i++) {
      const rule = filteredRules[i];
      if (evaluateRule(rule, params.session, customer)) {
        const details = getChatActionFromRule(rule)?.input?.pendingAssistant;
        if (details?.assistant) {
          return {
            assistant: details?.assistant,
            dialog: details?.startDialog,
          };
        }
      }
    }
  }

  // return the default assistant
  if (!proactive && store.settings.activeAssistant) {
    return {
      assistant: store.settings.activeAssistant,
    };
  }
  return false;
};
